module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_04-782104ecaaec3908f33d8eea03748758.jpg";